export const app = {
  connectToYourWhatsappNumber: 'התחבר למספר ה-WhatsApp שלך',
  connectYourWhatsappBotWithYourWhatsappNumber: 'התחבר את הבוט שלך ב-WhatsApp למספר ה-WhatsApp שלך',
  connect: 'התחבר',
};
